export function parseBlacklist(res) {
  if (!res || !Array.isArray(res)) return []

  return res
    .map(value => {
      if (typeof value !== 'string') return
      const splited = value.split(/:/g)
      if (splited.length !== 3) return
      return { serverName: splited[0], appName: splited[1], pmId: Number(splited[2]) }
    })
    .filter(Boolean)
}

// Filter blacklisted processes
export function filterServerStatuses(blacklist, serverStatuses) {
  if (blacklist.length) {
    for (const serverStatus of serverStatuses) {
      serverStatus.data.process = serverStatus.data.process.filter(process => {
        const isBlacklisted = blacklist.some(b => {
          return (
            b.serverName === serverStatus.server_name &&
            b.appName === process.name &&
            b.pmId === process.pm_id
          )
        })
        return !isBlacklisted
      })
    }
  }
}
